import { render } from "./TheSearchIndex.vue?vue&type=template&id=6763c846"
import script from "./TheSearchIndex.vue?vue&type=script&lang=js"
export * from "./TheSearchIndex.vue?vue&type=script&lang=js"

import "./TheSearchIndex.vue?vue&type=style&index=0&id=6763c846&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__